module.exports = __webpack_public_path__ + "img/emoji/thonkerguns.7ba4f33a10b643f437c3fd8dadda110a.png";